import React, {FC} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import {Checkbox, Row, Col} from 'antd'
import './style/Device.less'
import { GroupType} from '@/types/NewMachineTypes'
import {IdType} from '@/types/IdTypes'
import SelectForm from '@/components/Select/SelectForm'

interface DeviceTypes {
    groupList: (GroupType)[];
    groupId: IdType;
    changeGroupId: (id: IdType) => void;
    toggleAllSelected: (bool: boolean) => void;
    allSelectStaut: boolean;
    indeterminate?: boolean;
}
type DeviceProps = StylesType & DeviceTypes
const Device: FC<DeviceProps> = props => {
    const {prefixCls = 'gc_', className, groupList, groupId, changeGroupId, toggleAllSelected, allSelectStaut, indeterminate} = props

    return (
        <div className={classnames(className, prefixCls + 'mchaine_device')}>
            <Row align='middle' type='flex' gutter={[12, 0]}>
              <Col>
                <SelectForm
                  title='设备组名'
                selectValue={groupId}
                dataSource={groupList}
                value='id'
                lable='groupName'
                onChange={changeGroupId}
                ></SelectForm>
              </Col>
                <Col>
                    <Checkbox className={classnames('all_selected')} onChange={(e)=>toggleAllSelected(e.target.checked)} checked={allSelectStaut} indeterminate={indeterminate}>全选</Checkbox>
                </Col>
            </Row>
        </div>
    )
}


export default Device
